import { render, staticRenderFns } from "./StarMgtList.vue?vue&type=template&id=57ff8f2b&"
import script from "./StarMgtList.vue?vue&type=script&lang=js&"
export * from "./StarMgtList.vue?vue&type=script&lang=js&"
import style0 from "./StarMgtList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports